var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// src/components/MarkdownWrapper.tsx
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
var MarkdownWrapper = function (_a) {
    var content = _a.content;
    var _b = useState({
        ReactMarkdown: null,
        remarkGfm: null,
        rehypeKatex: null,
        remarkMath: null,
        SyntaxHighlighter: null,
        oneLight: null,
    }), Components = _b[0], setComponents = _b[1];
    useEffect(function () {
        var loadComponents = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, ReactMarkdownModule, remarkGfmModule, rehypeKatexModule, remarkMathModule, syntaxHighlighterModule, stylePrismModule;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            import('react-markdown'),
                            import('remark-gfm'),
                            import('rehype-katex'),
                            import('remark-math'),
                            import('react-syntax-highlighter/dist/cjs/prism'),
                            import('react-syntax-highlighter/dist/cjs/styles/prism/one-light'),
                        ])];
                    case 1:
                        _a = _b.sent(), ReactMarkdownModule = _a[0], remarkGfmModule = _a[1], rehypeKatexModule = _a[2], remarkMathModule = _a[3], syntaxHighlighterModule = _a[4], stylePrismModule = _a[5];
                        setComponents({
                            ReactMarkdown: ReactMarkdownModule.default,
                            remarkGfm: remarkGfmModule.default,
                            rehypeKatex: rehypeKatexModule.default,
                            remarkMath: remarkMathModule.default,
                            SyntaxHighlighter: syntaxHighlighterModule.default,
                            oneLight: stylePrismModule.default,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        loadComponents();
    }, []);
    if (!Components.ReactMarkdown) {
        return _jsx("div", { children: "Loading..." });
    }
    var ReactMarkdown = Components.ReactMarkdown, remarkGfm = Components.remarkGfm, rehypeKatex = Components.rehypeKatex, remarkMath = Components.remarkMath, SyntaxHighlighter = Components.SyntaxHighlighter, oneLight = Components.oneLight;
    return (_jsx(ReactMarkdown, { rehypePlugins: [rehypeKatex], remarkPlugins: [remarkGfm, remarkMath], components: {
            code: function (_a) {
                var node = _a.node, inline = _a.inline, className = _a.className, children = _a.children, props = __rest(_a, ["node", "inline", "className", "children"]);
                var match = /language-(\w+)/.exec(className || '');
                var code = String(children).replace(/\n$/, '');
                if (!inline && match) {
                    return (_jsx(Box, { sx: { position: 'relative' }, children: _jsx(SyntaxHighlighter, __assign({ style: oneLight, language: match[1], PreTag: "div", wrapLongLines: true }, props, { children: code })) }));
                }
                return (_jsx("code", __assign({ className: className }, props, { children: children })));
            }
        }, children: content }));
};
export default MarkdownWrapper;
